export enum AtomButtonLinkTypeEnum {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  DANGER = "danger",
  DISABLED = "disabled",
}
